import React from "react";
import SignatureCanvas from "react-signature-canvas";

const SignatureModal = ({
  isOpen,
  sigPad,
  saveSignature,
  clearSignature,
  signature,
  handleUploadSignature,
  uploadedSignature,
  formData,
  isChecked,
  isReadOnly,
  handleCheckboxChange,
  handleCancel,
  handleSubmitMLNOReview,
}) => {
  if (!isOpen) return null;

  // Inline styles
  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "white",
      padding: "2rem",
      borderRadius: "8px",
      maxHeight: "90vh",
      overflowY: "auto",
      width: "600px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    },
    signatureImage: {
      marginTop: "1rem",
      maxWidth: "100%",
      height: "auto",
      border: "1px solid #ccc",
    },
    buttonGroup: {
      display: "flex",
      gap: "10px",
      marginTop: "1rem",
    },
    uploadButton: {
      display: "inline-block",
      marginTop: "1rem",
      cursor: "pointer",
      backgroundColor: "#f0f0f0",
      padding: "8px 12px",
      borderRadius: "4px",
    },
    fileInput: {
      display: "none",
    },
    confirmationButtons: {
      display: "flex",
      justifyContent: "flex-end",
      gap: "10px",
      marginTop: "1.5rem",
    },
  };
const isConfirmDisabled = !(signature || uploadedSignature) || !isChecked;
  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div className="signature-container">
          <h3>MLNO Signoff</h3>
          <SignatureCanvas
            ref={sigPad}
            penColor="black"
            canvasProps={{ width: 300, height: 100, className: "signature-pad" }}
          />

          <div style={styles.buttonGroup}>
            <button onClick={saveSignature}>Save Signature</button>
            <button onClick={clearSignature}>Clear Signature</button>
          </div>

          {signature && (
            <img
              src={signature}
              alt="MLNO Signature"
              style={styles.signatureImage}
            />
          )}

          <p>Or Upload Signature Image:</p>
          <label className="upload-button">
                  Upload Signature
                  <input type="file" accept="image/*" onChange={handleUploadSignature} className="file-input" />
                </label>

          {uploadedSignature && (
            <img
              src={uploadedSignature}
              alt="Uploaded Signature"
              style={styles.signatureImage}
            />
          )}

          <div className="review-container" style={{ marginTop: "1rem" }}>
            <input
              type="checkbox"
              id="approve-request"
              checked={isChecked}
              onChange={handleCheckboxChange}
            />
            <label htmlFor="approve-request" style={{ marginLeft: "0.5rem" }}>
            I have reviewed the request in its entirety and approve the Request as the Designated Officer.
            </label>
          </div>

          <div style={styles.confirmationButtons}>
            <button
              onClick={handleCancel}
              style={{ backgroundColor: "gray", color: "white", padding: "8px 16px" }}
            >
              Cancel
            </button>
            <button
              onClick={handleSubmitMLNOReview}
              disabled={isConfirmDisabled}
              style={{ backgroundColor:isConfirmDisabled ? "lightgray" : "#07b1b0", color: "white", padding: "8px 16px", cursor: isConfirmDisabled ? "not-allowed" : "pointer"}}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignatureModal;
